import guide from "./js/guide";
import player from "./js/player";

[
	guide,
	player
].forEach( module => module._init() );